// @flow
import {
  contentType as tContentType,
  type ContentTypes,
} from '../types';

const exts = ['jpg', 'jpeg', 'png', 'jpeff', 'gif', 'tiff', 'raw', 'bmp', 'jfif'];

const normalizeName = (name?: ?string) => (name ? name.split(' ').filter(piece => {
  const pieces = piece ? piece.split('.') : [];
  if (pieces && pieces[pieces.length - 1]) {
    const lastPiece = pieces[pieces.length - 1];
    return !exts.includes(lastPiece);
  }
  return true;
}).join(' ') : '');

const normalizeRootFolderId = (rootFolderId: string) => rootFolderId.split('-R')[0];

const getContentDetailsSuffixId = (contentType: ContentTypes) => {
  switch (contentType) {
    case tContentType.STUDY_SET:
      return '-S';
    case tContentType.QUESTION_SET:
      return '-Q';
    case tContentType.FOLDER:
      return '-F';
    default:
      return '-N';
  }
};
export {
  normalizeRootFolderId,
  normalizeName,
  getContentDetailsSuffixId,
};
